import { isValidElement, type ReactElement, type ReactNode } from "react";

import { RadioCardItem, type RadioCardItemProps } from "./radio-card-item";

export const isRadioCardItem = (child?: ReactNode): child is ReactElement<RadioCardItemProps> =>
  isValidElement<RadioCardItemProps>(child) && child.type === RadioCardItem;
